import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { pollVote, questionEdit, questionLike, questionUnlike, repliesFetch, showLoginModal } from '../../../actions/index';
import { translate } from 'react-i18next';
import history from '../../../other/history';
// import style from './style.css';
import PollCardComponent from '../../../components/Elems/PollCard';
import ReplySortDropdown from '../../../components/Elems/ReplySortDropdown';
// import { ProfileThumb } from '../../../components/Common/CardComponents';
import ReplyCardContainer from '../ReplyCard';
import ReplyInputContainer from '../ReplyInput';
import GenericInputModal from '../../../components/Common/CardComponents/GenericInputModal';
import ShareModal from '../../../components/Common/CardComponents/Share';
import EmptyPlaceholder from '../../../components/Misc/EmptyPlaceholder';
import NotificationSystem from 'react-notification-system';
import {buildMapping} from '../../../other/ActionMapper';
import {myIsSet, esCape, gtmSend} from '../../../helpers';
import {getUrlParameter} from '@tickled-media/web-components.tm-helpers';
import Filters from '../../../other/filters';
import qs from 'qs';
import { Icon } from '../../../components/Common/Icon';
import cx from '../../../styles';
// import {mobileCheck} from '../../../helpers';
import AdCoreSlot from '../../../components/Ads/AdCoreSlot';

class PollElemContainer extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            replyPage: myIsSet(this.props, 'serverReqQuery.page') ? this.props.serverReqQuery.page : (Number(getUrlParameter('page')) || 1), 
            isEditModalOpen: false,
            isShareModalOpen: false,
            editTitle: '',
            editContent: '',
            modalImages: [],
            modalImagePreviews: [],
            isLoading: false,
            isShowNotification: true,
            selectedSort: myIsSet(this.props, 'data.reply_sorting') ? this.props.data.reply_sorting.filter((opt) => {if(opt.selected) return true; else return false;})[0].label : ''
        };
    }

    componentDidMount() {
        if (typeof this.refs.replyInput != "undefined") {
            this.replyInput = this.refs.replyInput.getWrappedInstance().getWrappedInstance();//coz of translate hoc
        }
        //auto vote
        if (this.props.ifTapPoll && this.props.userReducer.id && this.props.history.location.search.length) {
            const params = qs.parse(this.props.history.location.search.replace('?', '')),
            pollId = this.props.data.poll_choices[0].poll_id,
            tapPollChoiceId = params['tapPollChoiceId'];
            this.voteHandler(pollId, tapPollChoiceId);
        }
    }

    goToSingleView = () => {
        window.location.href = `/q/${this.props.data.topic.slug}/${this.props.id}`
    }

    handleTapPollLogin = (choiceId = null) => {
        //redirect to login
        history.push({
            pathname: `/login`,
            search: `?frpl=${this.props.tapPollCallbackUrl}&frpId=${choiceId}&gcbu=${this.props.tapPollGoogleCallbackUrl}`
        });
    }

    onContentClick = () => {
        return this.props.inFeed ? this.goToSingleView() : false;
    }

    onReplyClick = () => {
        gtmSend('dynamic', 'Poll Card', 'click-reply', this.props.match.path);
        if (!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `reply | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `reply | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else {
            this.props.inFeed
                ? this.goToSingleView()
                : this.replyInput.openReplyModal();
        }
    }

    onLikeClick = async () => {
        if (!this.props.ifTapPoll && !this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `like | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `like | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        }
        else if (this.props.ifTapPoll && !this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `like | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `like | ${this.props.match.path}`, 0, {action: 'Open'});
            this.handleTapPollLogin();
        }
        else if(!this.state.isLoading){
            const { index, inFeed, id, data } = this.props;
            gtmSend('dynamic', 'Poll Card', `click-${(data.likes.liked ? 'unlike' : 'like')}`, this.props.match.path);
            gtmSend('cw_reaction', 'Poll Card', 'Reaction', `${(data.likes.liked ? 'unlike' : 'like')}`, 0, {card_type: 'Poll Card', card_id: `${id}`, topic_name: `${data.topic.group.name}`, topic_id: `${data.topic.group.id}`});
            if(data.likes.liked){
                this.setState({isLoading: true});
                this.props.questionUnlike(index, inFeed, id)
                .then(() => {
                    this.setState({isLoading: false});
                });
            }
            else{
                this.setState({isLoading: true});
                await this.props.questionLike(index, inFeed, id)
                .then(() => {
                    this.setState({isLoading: false});
                });
            }
        }
    }

    voteHandler = (pollId, choiceId) => {
        if (this.props.ifTapPoll && !this.props.userReducer.id) {
            this.handleTapPollLogin(choiceId);
        } else {
            this.props.pollVote(this.props.id, this.props.index, this.props.inFeed, pollId, choiceId);
        }
    }

    share = () => {
        gtmSend('dynamic', 'Poll Card', 'click-share', this.props.match.path);
        if (this.props.ifTapPoll && !this.props.userReducer.id) {
            this.handleTapPollLogin();
        } else {
            this.setState({ isShareModalOpen: true });
        }
    }

    imageUrlToData = (url, callback) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
            const reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    populatePostImages = (images = []) => {
        if (images.length) {
            //empty
            this.setState({
                modalImagePreviews: [],
                modalImages: []
            });
            for (const k in images) {
                this.imageUrlToData(images[k].image, (d) => {
                    this.setState({
                        modalImagePreviews: [...this.state.modalImagePreviews, d],
                        modalImages: [...this.state.modalImages, d.split(',')[1]]
                    });
                });
            }
        }
    }

    onEditModalImageUpload = (e) => {
        if (e.target.files.length) {
            gtmSend('dynamic', 'Poll Card Edit', 'click-image-upload', '');
            for (let k = 0; k < e.target.files.length; k++) {
                const reader = new FileReader();
                reader.readAsDataURL(e.target.files[k]);
                reader.onload = (i) => {
                    const base64Result = i.target.result;
                    this.setState({
                        modalImagePreviews: [...this.state.modalImagePreviews, base64Result],
                        modalImages: [...this.state.modalImages, base64Result.split(',')[1]]
                    });
                };
            }
        }
    }

    onPreviewImageRemove = (index) => {
        gtmSend('dynamic', 'Poll Card Edit', 'click-remove-image-preview', '');
        this.setState({
            modalImagePreviews: [...this.state.modalImagePreviews.slice(0, index), ...this.state.modalImagePreviews.slice(index + 1)],
            modalImages: [...this.state.modalImages.slice(0, index), ...this.state.modalImages.slice(index + 1)]
        });
    }

    openEditModal = () => {
        this.setState({ isEditModalOpen: true });
    }

    closeEditModal = () => {
        this.setState({ isEditModalOpen: false });
    }

    onEditModalOpen = () => {
        const {title, message, images} = this.props.data.topic;
        this.populatePostImages(images);
        this.setState({
            editTitle: title,
            editContent: message
        });
        //dialog fix
        const state = {};
        history.replace({ ...history.location, state });
    }

    onEditModalSubmit = (e) => {
        e.preventDefault();
        const title = esCape(this.state.editTitle),
            message = esCape(this.state.editContent);
        if(message.length < 10) return this._addNotificationToModal(this.props.t('char_limit_desc'), 'error');
        if(title.length < 10) return this._addNotificationToModal(this.props.t('char_limit_title'), 'error');
        // let anonymous = e.target.anonymous.value;
        const nsfw = e.target.nsfw ? +(e.target.nsfw.checked) : 0,
            questionId = this.props.id;
        // let isActive = 1;
        gtmSend('dynamic', 'Poll Card Edit', 'click-submit', `submit:${questionId}`);
        //
        if (this.state.modalImages.length) {
            this.props.questionEdit(questionId, message, title, nsfw, [{ image: this.state.modalImages[0] }])
                .then(() =>{
                    if(!this.props.postReducer.error){
                        this.closeEditModal();
                    }else {
                        this._addNotificationMessageToModal(this.props.postReducer.error, 'error');
                    }
                });
        } else {
            this.props.questionEdit(questionId, message, title, nsfw)
                .then(() =>{
                    if(!this.props.postReducer.error){
                        this.closeEditModal();
                    }else {
                        this._addNotificationMessageToModal(this.props.postReducer.error, 'error');
                    }
                });
        }
    }

    onRepliesFetch = () => {
        if (!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `read more replies | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `read more replies | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        }
        else{
            if (this.props.singleReplyMode) {
                this.goToSingleView();
                // window.location.reload(true);
            } else {
                const page = this.state.replyPage;
                this.props.repliesFetch(this.props.id, Number(page) + 1, this.state.selectedSort)
                .then(() => {
                    if(this.props.userReducer.id){
                        this.setState({
                            replyPage: Number(page) + 1
                        });
                    }
                });
            }
        }
    }

    changeReplySorting = (value) => {
        this.setState({
            replyPage: (Number(getUrlParameter('page')) || 1),
            selectedSort: value
        });
    }

    addNotification = (message, level) => {
        if(this.state.isShowNotification){
            this.setState({isShowNotification: false});
            this._notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 3,
                position: 'bc'
            });

            setTimeout(()=>{
                this.setState({isShowNotification: true})
            },3000);
        }
    }

    onHashClick = (hashtag) => {
        let editContent = this.state.editContent;
        editContent += ` ${hashtag}`;
        this.setState({editContent});
        document.getElementById("content").focus();
    }

    render() {
        const { data, index, inFeed, id, t, configReducer, ifTapPoll, userReducer, match, appReducer, postReducer, singleReplyMode, status } = this.props,
            title = Filters.process(['feedhashtagify'], data.topic.title),
            message = Filters.process(['feedhashtagify'], data.topic.message),
            // title = data.topic.title,
            slug = data.topic.slug,
            nsfw = data.topic.nsfw,
            images = data.topic.images,
            topic = data.topic.group,
            author = data.topic.user,
            lastSeen = data.topic.nice_time,
            replies = data.replies,
            alreadyVoted = data.already_voted,
            totalVotes = data.total_votes,
            url = data.topic.url,
            // ads = configReducer.ads,
            dfp = configReducer.dfp,
            reply_count = data.topic.reply_count,
            responseBar = {
                replyCount: reply_count,
                likes: data.likes,
                onLikeClick: this.onLikeClick,
                onReplyClick: this.onReplyClick,
                onShareClick: this.share
            },
            actions = buildMapping(
                'question',
                data.actions,
                {
                    id,
                    cardName: 'Poll Card',
                    authorId: author.id,
                    authorName: author.fullname,
                    hideUrl: data.hide_url,
                    position: (typeof document != 'undefined' ? document.documentElement.scrollTop : 0),
                    adminUrl: (data.backend_url ? data.backend_url : ''),
                    subType: this.props.subType,
                    detailPage: this.props.detailPage,
                    elemRef: this,
                    inFeed,
                    topic,
                    t
                },
                this.context.store.dispatch
            );

        return (
            <div 
                className={cx("question-elem-containers", inFeed ? "in-feed-design" : "detail-design", "tap-poll-elem")}>

                {
                    this.props.contentHub && 
                    <a className={cx('content-hub-overlay-wrapper')} href={url}></a>
                }
                <NotificationSystem ref={n => this._notificationSystem = n} style={false} />

                <div className={cx("main-elem-section")}>
                    <PollCardComponent index={index}
                        siteUrl={configReducer.siteUrl}
                        message={Filters.process(['linkify'], message)}
                        title={Filters.process(['linkify'], title)}
                        images={images}
                        topic={topic}
                        author={author}
                        lastSeen={lastSeen}
                        actions={actions}
                        responseBar={responseBar}
                        currentState={alreadyVoted}
                        totalVotes={totalVotes}
                        votes={data.votes}
                        pollChoices={data.poll_choices}
                        pollType={data.poll_type}
                        pollTypePlaceholder={data.poll_type_placeholder}
                        id={id}
                        inFeed={inFeed}
                        ifTapPoll={ifTapPoll}
                        voteHandler={this.voteHandler}
                        viewUrl={`q/${data.topic.slug}/${id}`}
                        onContentClick={this.onContentClick} 
                        appReducer={appReducer}
                        cardName='Poll Card'
                        botIndex={data.topic.bot_index}
                        match={match}
                        url={url}
                        status={status}
                        contentHub={this.props.contentHub}    />

                    {
                        ifTapPoll && !alreadyVoted &&
                        <button style={{ margin: "5px 15px 5px 15px", padding: "5px 15px" }}
                            onClick={() => this.addNotification(t('onboarding_status_check'), 'error')}>{t('community_poll_vote_button')}</button>
                    }
                </div>
                
                {/*
                    !inFeed && !ifTapPoll && ads.networkId &&
                    <div className={cx("only-mobile", "ad-wrap")}>
                            {
                                mobileCheck() && 
                                <AdCoreSlot networkId={ads.networkId} 
                                    adUnit={ads.mobile.top.unit}
                                    styleClass={ads.mobile.top.styleClass}
                                    size={[ads.mobile.top.w, ads.mobile.top.h]}
                                    id={ads.mobile.top.id} />
                            }
                    </div>
                */}

                {
                    !(postReducer.data && postReducer.data.topic && postReducer.data.topic.nsfw === 1) &&
                    !inFeed && !ifTapPoll && dfp.networkId && myIsSet(dfp, 'ros.banners.side_1.id') &&
                    <div className={cx("only-mobile", "ad-wrap", "shadow-card")}>
                        <AdCoreSlot 
                            dfpKeys={['ros','banners','side_1']}
                            adObj={dfp.ros.banners.side_1}
                            device="mobile"
                            customClass="showAddText"
                            styleClass={dfp.ros.banners.side_1.styleClass} 
                            id={dfp.ros.banners.side_1.id}
                            app={appReducer}
                        />
                    </div>
                }

                {
                    !ifTapPoll &&
                    <div className={cx("reply-list-wrap")}>
                        {
                            !inFeed && replies.length != 0 &&
                            <ReplySortDropdown
                                t={t}
                                replyCount={responseBar.replyCount}
                                cardName='Poll Card'
                                topic={topic}
                                reply_sorting={data.reply_sorting}
                                changeReplySorting={this.changeReplySorting}
                                selectedSort={this.state.selectedSort}
                                id={this.props.id}
                                repliesFetch={this.props.repliesFetch}
                            />
                        }

                        {
                            !inFeed &&
                            <div className={cx('shadow-card')}>
                                <ReplyInputContainer inFeed={inFeed}
                                    id={id}
                                    slug={slug}
                                    ref='replyInput'
                                    cardName='Poll Card'
                                    match={match} />
                            </div>
                        }

                        {
                            replies.map((reply, i) => {
                                return <ReplyCardContainer key={i}
                                    postId={id}
                                    slug={slug}
                                    cardIndex={index}
                                    replyIndex={i}
                                    reply={reply}
                                    inFeed={inFeed}
                                    match={match}
                                    singleReplyMode={singleReplyMode}
                                    cardName='Poll Card'
                                    status={status}
                                    topic={topic} />;
                            })
                        }

                        {
                            inFeed
                                ?
                                false && !!data.replies.length &&
                                <div className={cx("more-reply-link", "in-feed")}>
                                    {
                                        data.more_reply_count == 0
                                        ?
                                            <span onClick={this.goToSingleView}>
                                                {`${data.more_reply_count} ${data.more_reply_count > 1 ? t('detail_reply_count_plural') : t('detail_reply_count')}`}
                                            </span>
                                        :
                                            ""
                                    }

                                    {!!data.more_reply_count && <Icon name="right-double-arrow-regular-gray-md" />}
                                </div>
                                :
                                !!data.more_reply_count &&
                                <div className={cx("more-reply-link")}>
                                    <a href={`${match.url}?page=${Number(this.state.replyPage) + 1}`} className={cx("btn", "btn-primary")} onClick={(e) => {e.preventDefault(); this.onRepliesFetch();}}>
                                        <span>{`${data.more_reply_count} ${data.more_reply_count > 1 ? t('detail_reply_count_plural')  : t('detail_reply_count')}`}</span>

                                        <Icon name="down-double-arrow-regular-white-md" />

                                        { postReducer.isLoading && !appReducer.showLoginModal && <span className={cx("spin-loader")} /> }
                                    </a>
                                </div>
                        }
                    </div>
                }

                {
                    inFeed && !ifTapPoll &&
                    <ReplyInputContainer inFeed={inFeed}
                        id={id}
                        slug={slug}
                        ref='replyInput'
                        match={match} />
                }

                {
                    !(inFeed || data.replies.length || ifTapPoll) &&
                    <EmptyPlaceholder content={t('detail_empty_response_placeholder')} />
                }

                {
                    !inFeed &&
                    <GenericInputModal isModalOpen={this.state.isEditModalOpen}
                        eventHandlers={{
                            onModalOpen: this.onEditModalOpen,
                            onModalClose: () => this.setState({ isEditModalOpen: false }),
                            onSubmit: this.onEditModalSubmit,
                            onImageUpload: this.onEditModalImageUpload,
                            onPreviewImageRemove: this.onPreviewImageRemove,
                            onContentChange: v => this.setState({ editContent: v }),
                            onHashClick: this.onHashClick,
                            onTitleChange: v => this.setState({ editTitle: v }),
                            refAddNotification: (f) => this._addNotificationToModal = f,
                            refAddNotificationMessage: (f) => this._addNotificationMessageToModal = f
                        }}
                        gtmLabel={'Poll Card Edit'}
                        title={this.state.editTitle}
                        content={this.state.editContent}
                        imagePreviews={this.state.modalImagePreviews}
                        user={userReducer}
                        showUploadInput={true}
                        showUploadGif={true}
                        showNSFW={true}
                        showHash={true}
                        isNSFWChecked={nsfw}
                        ifEditing={true}
                        isPoll={true}
                        topic={topic}
                        linkPreview={this.props.composeReducer.linkPreview}
                        buttonLabel={t('add_edit_save')} />
                }

                {
                    <ShareModal isModalOpen={this.state.isShareModalOpen}
                        position={typeof document != 'undefined' ? document.documentElement.scrollTop : 0}
                        shareType='question'
                        cardName='Poll Card'
                        id={id}
                        siteUrl={configReducer.siteUrl}
                        slug={`q/${slug}/${id}`}
                        username={userReducer.full_name}
                        topic={topic}
                        t={t}
                        onModalClose={() => this.setState({ isShareModalOpen: false })} />
                }

            </div>
        );
    }

}

PollElemContainer.contextTypes = {
    store: PropTypes.object.isRequired
};

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        pollVote,
        questionEdit,
        questionLike,
        questionUnlike,
        repliesFetch,
        showLoginModal
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(PollElemContainer));
